// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class ProductPromotionModel {
  allowableDiscountDollars: number;
  allowableDiscountPercentage: number;
  authorizationCode: string;
  affectedMaterial: string;
  discount: number;
  affectedMaterialText: string;
  isRequestPending: boolean;
}
